import React from 'react'
import { withIcon } from '../../withIcon'

function ArrowUpIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.1831 4.18306C11.4271 3.93898 11.8229 3.93898 12.0669 4.18306L18.0669 10.1831C18.311 10.4271 18.311 10.8229 18.0669 11.0669C17.8229 11.311 17.4271 11.311 17.1831 11.0669L12.25 6.13388V18.625C12.25 18.9702 11.9702 19.25 11.625 19.25C11.2798 19.25 11 18.9702 11 18.625V6.13388L6.06694 11.0669C5.82286 11.311 5.42714 11.311 5.18306 11.0669C4.93898 10.8229 4.93898 10.4271 5.18306 10.1831L11.1831 4.18306Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ArrowUpIcon)
